// Atelier du Thé — ajout au panier des cartes produit adt-* et de la fiche adt-product (bouton [data-adt-add="<variant id>"]).
// Options : data-adt-qty (sélecteur de l'input quantité), [data-adt-label] (élément texte du bouton).
// Même requête que product-form.js de FullStack : sections du tiroir renvoyées puis CartUpdatedEvent,
// ce qui rafraîchit le tiroir panier, met à jour le compteur et l'ouvre.
import { CartUpdatedEvent } from '@theme/events';

if (!window.adtCartBound) {
  window.adtCartBound = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-adt-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    const qtyInput = btn.dataset.adtQty ? document.querySelector(btn.dataset.adtQty) : null;
    const quantity = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
    const label = btn.querySelector('[data-adt-label]') || btn;

    const drawer = document.querySelector('cart-drawer');
    const sections = ['auto-gifts'];
    if (drawer) sections.push(drawer.dataset.sectionId);

    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.adtAdd), quantity }], sections: sections.join(',') }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || "Der Artikel konnte nicht hinzugefügt werden.");

      const current = document.querySelector('cart-icon')?.getCurrentItemCount();
      document.dispatchEvent(
        new CartUpdatedEvent({}, { itemCount: current != null ? current + quantity : undefined, source: 'adt-product-card', sections: data.sections }),
      );
      label.textContent = 'Zum Warenkorb hinzugefügt';
      btn.classList.add('is-added');
    } catch (err) {
      document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: err.message } }));
    } finally {
      btn.classList.remove('is-loading');
    }
  });
}
